import { getMMDDWithHyphen, isValidDate } from '@shared/lib/utils/time'

export const simplifyDateDisplay = (text: unknown): string =>
  isValidDate(text) ? getMMDDWithHyphen(text) : `${text}`
